import { render, staticRenderFns } from "./RequestCancellation.vue?vue&type=template&id=16db7c6e&scoped=true"
import script from "./RequestCancellation.vue?vue&type=script&lang=ts"
export * from "./RequestCancellation.vue?vue&type=script&lang=ts"
import style0 from "./RequestCancellation.vue?vue&type=style&index=0&id=16db7c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db7c6e",
  null
  
)

export default component.exports